<template>
  <div class="row text-center">
    <div class="col-12">
      <section class="login">
        <div class="container">
          <div class="login__group">
            <h1 class="login__title">Entrar</h1>
            <p class="login__resume">
              Já possui conta? Conecte-se para agendar e acompanhar as suas
              consultas.
            </p>

            <form class="login__form">
              <div v-show="alertError" class="alert alert-danger" role="alert">
                Email e/ou senha estão incorretos
              </div>

              <div class="form-group">
                <input
                  id="exampleInputEmail1"
                  v-model="$v.user.email.$model"
                  type="email"
                  class="form-control"
                  aria-describedby="emailHelp"
                  placeholder="E-mail"
                />

                <div v-if="$v.user.email.$error" class="error">
                  <div v-if="!$v.user.email.required" class="error">
                    Campo obrigatório
                  </div>
                  <div v-if="!$v.user.email" class="error">Email inválido</div>
                </div>
              </div>

              <div class="form-group">
                <input
                  id="exampleInputPassword1"
                  v-model="$v.user.password.$model"
                  type="password"
                  class="form-control"
                  placeholder="Senha"
                />
                <div v-if="$v.user.password.$error" class="error">
                  <div v-if="!$v.user.password.required" class="error">
                    Campo obrigatório
                  </div>
                </div>
              </div>

              <button
                type="submit"
                class="button3"
                @click.prevent="sendLogin()"
              >
                Entrar
              </button>
            </form>

            <div class="login__forgot">
              <a href="/recuperarSenha" class="login__forgot-item">
                Esqueci a senha
              </a>
            </div>
          </div>
        </div>
      </section>

      <section class="option-account">
        <div class="container option-account__wrapper">
          <p class="create-account__item">
            Primeira vez aqui?
            <a href="/cadastrar">Crie uma conta</a>
          </p>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { authMethods, authComputed, authGetter } from "./../state/helpers";
import { required, email } from "vuelidate/lib/validators";

export default {
  name: "Login",
  data() {
    return {
      user: {
        email: "",
        password: ""
      },
      redirectFrom: ""
    };
  },

  validations: {
    user: {
      email: { required, email },
      password: { required }
    }
  },

  mounted() {
    this.redirectFrom = this.$route.query.redirectFrom;
  },

  methods: {
    ...authMethods,
    sendLogin() {
      this.$v.user.$touch();
      if (!this.$v.user.$invalid)
        this.login({ ...this.user, redirectFrom: this.redirectFrom })
          .then(path => {
            this.$router.push({ path });
            this.isDoctor &&
              this.initMemed(
                this.$store.state.user.currentUser.doctor_property.memed_token
              );
          })
          .catch(error => error);
    },
    initMemed(token) {
      let script = document.createElement("script");
      script.setAttribute("type", "text/javascript");
      script.setAttribute("id", "memed-script");
      script.setAttribute("data-color", "#1abc9c");
      script.setAttribute("data-token", token);
      script.setAttribute("data-container", "memed-container");
      script.src =
        "https://sandbox.memed.com.br/modulos/plataforma.sinapse-prescricao/build/sinapse-prescricao.min.js";
      document.body.appendChild(script);
    }
  },
  computed: {
    ...authComputed,
    ...authGetter,
    isDoctor() {
      return this.$store.state.user.userRole === "doctor";
    }
  }
};
</script>
